module.exports = __webpack_public_path__ + "static/img/logos.5057ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos.png
// module id = ZYYH
// module chunks = 20